import { system } from '@workday/canvas-tokens-web'

const baseStyleHeader = {
  py: 6,
  pl: 6,
  pr: 12
}

const baseStyleCloseButton = {
  position: 'absolute',
  _focusVisible: {
    boxShadow: 'middleOutline'
  }
}

const baseStyleBody = {
  px: 6,
  pt: 0,
  pb: 6,
  flex: 1,
  overflow: 'auto'
}

const baseStyle = ({ theme }) => ({
  overlay: {
    bgColor: theme.isSanaRebrand ? `var(${system.color.surface.overlay.scrim})` : 'rgba(0, 0, 0, 0.48)'
  },
  dialog: {
    boxShadow: theme.isSanaRebrand ? '6' : 'lg'
  },
  header: baseStyleHeader,
  closeButton: {
    ...baseStyleCloseButton,
    ...(theme.isSanaRebrand ? { borderRadius: 'full', w: '40px', h: '40px' } : {}),
    top: theme.isSanaRebrand ? `var(${system.padding.xs})` : '1.5rem',
    right: theme.isSanaRebrand ? `var(${system.padding.xs})` : '1.5rem'
  },
  body: theme.isSanaRebrand
    ? {
        ...baseStyleBody,
        // Only the variable is set under :has() so consumer padding props still win.
        pb: 'var(--vndly-drawer-body-pb, var(--chakra-space-6))',
        '&:has(~ .chakra-modal__footer)': { '--vndly-drawer-body-pb': '0px' }
      }
    : baseStyleBody,
  footer: {
    p: 6,
    justifyContent: 'flex-start',
    borderTop: theme.isSanaRebrand ? 'none' : '1px solid',
    borderColor: `var(${system.color.border.strong})`
  }
})

/**
 * Used remove the pointer event from the drawer overlay so we can allow
 * the rest of the page to be clickable while the drawer is open
 */
const variantAlwaysOpen = ({ theme }) => ({
  dialog: {
    pointerEvents: 'auto',
    boxShadow: theme.isSanaRebrand ? '5' : 'lg'
  },
  dialogContainer: {
    pointerEvents: 'none'
  }
})

export const Drawer = {
  baseStyle,
  variants: {
    alwaysOpen: variantAlwaysOpen
  },
  defaultProps: {
    size: 'sm'
  }
}
